/**
 * A node in the DOM tree.
 *
 * @external Node
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node Node}
 */

(function() {
    'use strict';
    let sectionThree = true;// delete this

    const mobile = matchMedia('(max-width: 1024px)');
    const ie = navigator.userAgent.indexOf('MSIE ') >= 0 || navigator.userAgent.indexOf('Trident/') >= 0 || navigator.userAgent.indexOf('Edge/') >= 0;

    let main;
    let sections;
    let subSections;
    let videoQuality = 'HD';

    const setQuality = function() {
        if (mobile.matches) {
            videoQuality = 'M';
        } else {
            if (window.matchMedia('(max-width: 640px)').matches) {
                videoQuality = 'SSD';
            } else if (window.matchMedia('(max-width: 1200px)').matches && window.matchMedia('(min-width: 640px)').matches) {
                videoQuality = 'SD';
            } else if (window.matchMedia('(min-width: 1200px)').matches) {
                videoQuality = 'HD';
            }
        }
    };

    let contentVideoPaths = {
        'video_0_1': {
            'HD': 'media/vid/flood/section-0/ServPro-desktopPrimary.mp4',
            'SD': 'media/vid/flood/section-0/ServPro-desktopPrimary_SD.mp4',
            'SSD': 'media/vid/flood/section-0/ServPro-desktopPrimary_SSD.mp4',
            'M': 'media/vid/flood/section-0/ServPro-desktopPrimary_Mobile.mp4',
        },
        'video_1_4': {
            'HD': 'media/vid/flood/section-1/ServPro-spirit-of.mp4',
            'SD': 'media/vid/flood/section-1/Servpro-spirit-of_SD.mp4',
            'SSD': 'media/vid/flood/section-1/Servpro-spirit-of_SSD.mp4',
            'M': 'media/vid/flood/section-1/ServPro-spirit-of_Mobile.mp4',
        },
        'video_1_1': {
            'HD': 'media/vid/flood/section-1/ServPro-water-still-rising.mp4',
            'SD': 'media/vid/flood/section-1/ServPro-water-still-rising_SD.mp4',
            'SSD': 'media/vid/flood/section-1/ServPro-water-still-rising_SSD.mp4',
            'M': 'media/vid/flood/section-1/ServPro-water-still-rising_Mobile.mp4',
        },
        'video_1_2': {
            'HD': 'media/vid/flood/section-1/ServPro-thousand-year-storm.mp4',
            'SD': 'media/vid/flood/section-1/ServPro-thousand-year-storm_SD.mp4',
            'SSD': 'media/vid/flood/section-1/ServPro-thousand-year-storm_SSD.mp4',
            'M': 'media/vid/flood/section-1/ServPro-thousand-year-storm_Mobile.mp4',
        },
        'video_1_3': {
            'HD': 'media/vid/flood/section-1/ServPro-poem.mp4',
            'SD': 'media/vid/flood/section-1/ServPro-poem_SD.mp4',
            'SSD': 'media/vid/flood/section-1/ServPro-poem_SSD.mp4',
            'M': 'media/vid/flood/section-1/ServPro-poem_Mobile.mp4',
        },
        'video_2_0': {
            'HD': 'media/vid/flood/section-2/Servpro-nerve-of-that-water.mp4',
            'SD': 'media/vid/flood/section-2/Servpro-nerve-of-that-water_SD.mp4',
            'SSD': 'media/vid/flood/section-2/Servpro-nerve-of-that-water_SSD.mp4',
            'M': 'media/vid/flood/section-2/Servpro-nerve-of-that-water_Mobile.mp4',
        },
        'video_3_0': {
            'HD': 'media/vid/flood/section-3/Servpro-let-life-flow.mp4',
            'SD': 'media/vid/flood/section-3/Servpro-let-life-flow_SD.mp4',
            'SSD': 'media/vid/flood/section-3/Servpro-let-life-flow_SSD.mp4',
            'M': 'media/vid/flood/section-3/Servpro-let-life-flow_Mobile.mp4',
        },

    };

    /**
     * Convenient document.getElementById delegate
     * @param {String} s element id
     * @return {DOMNode} node with id 's' or null if dne
     */
    function gid(s) {
        return document.getElementById(s);
    }

    let thisPlayer;
    const cnnHeader = gid('cnn_header');
    const sponsorContentHeader = gid('sponsor-content-header');
    const scrollguide = gid('scroll-guide');
    const section = gid('section-0');
    const header = gid('header-opening');
    const mainNav = gid('main-nav');
    const siteNavFlood = gid('site-nav-flood');
    // SECTION 1
    const section1 = gid('section-1');
    const bg1 = gid('bg1');
    const storyVideo = gid('subSection1_1');
    const servproText = gid('subSection1_2');
    const textMapBase = gid('subSection1_3');
    const storyImage = gid('subSection_image');
    const mapLayers = gid('subSection_map');
    const poemVideo = gid('subSection1_4');
    const s1Item1 = gid('s1_item1');
    const s1Item2 = gid('s1_item2');
    const s1Item3 = gid('s1_item3');
    const s1Item4 = gid('s1_item4');
    const s1Item5 = gid('s1_item5');
    const s1Item6 = gid('s1_item6');
    const s1Item7 = gid('s1_item7');
    const s1Item8 = gid('s1_item8');
    const scrollcopy1 = gid('scrollcopy_1_1');
    const scrollwrapper1 = gid('scrollwrapper_1_1');
    const scrollcopy5 = gid('scrollcopy_1_5');
    const scrollwrapper5 = gid('scrollwrapper_1_5');
    const videoBackground01 = gid('video_background_0_1_id');
    const videoBackground11 = gid('video_background_1_1_id');
    const videoBackground12 = gid('video_background_1_2_id');
    const videoBackground13 = gid('video_background_1_3_id');
    const videoBackground14 = gid('video_background_1_4_id');
    // SECTION 2
    const storyVideo21 = gid('subSection2_5');
    const slideshow21 = gid('subSection2_6');
    const s2Item1 = gid('s2_item1');
    const s2Item2 = gid('s2_item2');
    const s2Item3 = gid('s2_item3');
    const s2Item4 = gid('s2_item4');
    const s2Item5 = gid('s2_item5');
    const s2Item6 = gid('s2_item6');
    const s2Item7 = gid('s2_item7');
    const videoBackground20 = gid('video_background_2_0_id');
    // SECTION 3
    const section3 = gid('section-3');
    const bg3 = gid('bg3');
    const storyVideo30 = gid('subSection3_7');
    const videoBackground30 = gid('video_background_3_0_id');
    const subSection3Image = gid('subSection3_8');
    const mobileInfographic38 = gid('mobile-infographic3_8');

    let currentLoc = 0;
    let lastLoc;
    let navInc = 0;
    let navArr = [];
    /**
     * Set Video palyers sources
     */
    function setVideoSrc() {
        setQuality();
        videoBackground01.src = contentVideoPaths.video_0_1[videoQuality];
        videoBackground11.src = contentVideoPaths.video_1_1[videoQuality];
        videoBackground12.src = contentVideoPaths.video_1_2[videoQuality];
        videoBackground13.src = contentVideoPaths.video_1_3[videoQuality];
        videoBackground14.src = contentVideoPaths.video_1_4[videoQuality];
        videoBackground20.src = contentVideoPaths.video_2_0[videoQuality];
        if (sectionThree) videoBackground30.src = contentVideoPaths.video_3_0[videoQuality];
    }

    setVideoSrc();
    /**
     * Create a synthetic event with optional data and dispatch to a target DOM node.
     *
     * @param {string} type - The event type, e.g. 'click', 'scroll', or a custom name
     * @param {external:Node} element - The DOM node on which to dispatch the event
     * @param {string} data - Optional data to pass with the event
     */
    function dispatchSyntheticEvent(type, element, data) {
        let event;

        if (ie) {
            event = document.createEvent('Event');
            event.initEvent(type, true, true);
        } else {
            event = new Event(type);
        }

        event.data = data;

        element.dispatchEvent(event);
    }


    /** Entry point. Bootstrap code: Configure and await dependencies, then call {@link init} */
    (function main() {
        document.addEventListener('DOMContentLoaded', init);
    }());


    /**
     * Begins site build
     */
    function init() {
        main = gid('main');

        sections = Array.from(main.querySelectorAll('.section'));
        subSections = Array.from(main.querySelectorAll('.sub-section'));
        // videoLoops = Array.from(main.querySelectorAll('.vbg'));

        if (ie) {
            let tween = null;

            document.body.addEventListener('wheel', event => {
                event.preventDefault();

                if (tween !== null) {
                    tween.kill();
                }
                tween = TweenLite.to({scroll: window.pageYOffset}, 0.1, {
                    scroll: window.pageYOffset + event.deltaY * 1.25,
                    onUpdate: ({target: {scroll}}) => scrollTo(0, scroll),
                    onUpdateParams: ['{self}'],
                    onComplete: () => tween = null,
                });
            });
        }

        window.addEventListener('scroll', scroll, Modernizr.passiveeventlisteners ? {passive: true} : false);
        let index = 0;
        sections.forEach(div => {
            div.addEventListener('scroll-update', function track({data: {percent}}) {
                if (percent > 0) {
                    index++;
                    // ga('send', 'event', 'depth', (index));
                    gtag('event', 'depth', {'index': index});
                    div.removeEventListener('scroll-update', track);
                }
            });
        });

        subSections.forEach(sub =>

            sub.addEventListener('sub-scroll-update', function({data: {bounds}}) {
                let top = bounds.top;
                // let bottom = bounds.bottom;
                let vh = window.innerHeight / 100;
                let vid = sub.querySelector('.vbg');
                let embed = sub.querySelector('.video-embed');

                if (embed!==null) {
                    if ((top < (100*vh)) && (top > -(100*vh))) {
                        // do nothing
                    } else {
                        if (embed.offsetLeft===0) {
                            let click = sub.querySelector('.video-click');
                            scrollguide.style.visibility = 'visible';
                            thisPlayer.pause();
                            embed.style.left = '-100%';
                            click.style.left = '0px';
                        }
                    }
                }
                // play or pause videos whether they are in view or not
                if (vid!==null) {
                    if ((top < (100*vh)) && (top > -(100*vh))) {
                        vid.play();
                    } else {
                        vid.pause();
                    }
                }
                // set the location nuber for firing any specific special events
                if ((top < (50*vh)) && (top > -(50*vh))) {
                    setLoc(sub);
                }
            },
            createNavItem(sub)

            ));

        TweenLite.defaultEase = Linear.easeNone;

        initSection0Timeline();
        initSection1Timeline();
        initSection2Timeline();
        if (sectionThree) initSection3Timeline();

        initSection1Part3Video();
        initSection1Part4Video();
        initSection2Part0Video();
        if (sectionThree) initSection3Part0Video();

        scroll();
        initLazyLoad();
    }
    /**
     *  Set Loc
     * @param {string} s - The event type, e.g. 'click', 'scroll', or a custom name
     */
    function setLoc(s) {
        currentLoc = parseInt(s.getAttribute('sub'));
        // currentSection = parseInt(s.getAttribute('section'));

        if (currentLoc !== lastLoc) {
            setNav();
        }
        lastLoc = currentLoc;
    }
    /**
     * Create a nav item
     * @param {string} sub - The event type, e.g. 'click', 'scroll', or a custom name
     */
    function createNavItem(sub) {
        let section = gid('section-'+sub.getAttribute('section'));

        let imgSrc = 'navigation_panel.png';
        if (sub.className.indexOf('navVid') >= 0) imgSrc = 'navigation_video.png';
        if (sub.className.indexOf('navAud') >= 0) imgSrc = 'navigation_sound.png';
        if (sub.className.indexOf('navTxt') >= 0) imgSrc = 'navigation_text.png';
        if (sub.className.indexOf('navInf') >= 0) imgSrc = 'navigation_infographic.png';
        if (sub.className.indexOf('navSli') >= 0) imgSrc = 'navigation_slideshow.png';

        navInc++;
        let dot = document.createElement('div');
        mainNav.appendChild(dot);
        dot.id = 'navItem'+navInc;
        dot.className = 'dot_inactive';
        dot.style.cssText += 'background-image:url("media/img/'+imgSrc+'");background-size: 38px 18px; background-repeat: no-repeat;';
        dot.setAttribute('inc', navInc);
        dot.addEventListener('click', function(e) {
            let dot = e.target;
            let num = dot.getAttribute('inc');
            let offset = navArr[num-1];

            const vh = window.innerHeight / 100;

            const from = document.documentElement.scrollTop || document.body.scrollTop;
            const to = section.getBoundingClientRect().top + offset * vh;
            const duration = Math.min(1, Math.abs(to - from) / 2500);
            TweenLite.to([document.documentElement, document.body], duration, {scrollTop: `+=${to}`, ease: Sine.easeInOut});
        });
    }
    /**
     * Reset the navigation
     */
    function resetNav() {
        let children = mainNav.children;
        for (let i = 0; i < children.length; i++) {
            children[i].className = 'dot_inactive';
        }
    }
    /**
     * Create a new nav
     */
    function setNav() {
        resetNav();
        let currNav = gid('navItem'+(currentLoc+1));
        currNav.className = 'dot_active';

        let endFrame = 7;
        if (sectionThree) endFrame = 8;

        if (currentLoc===endFrame-1) scrollguide.style.opacity = 0.8;
        if (currentLoc===endFrame) scrollguide.style.opacity = 0;
    }
    /**
     * scroll detection
     */
    function scroll() {
        subSections.forEach(sub => {
            const r = sub.getBoundingClientRect();
            dispatchSyntheticEvent('sub-scroll-update', sub, Object.create(null, {
                'bounds': {value: r},
            }));
        });

        sections.forEach(div => {
            const r = div.getBoundingClientRect();
            const top = -(r.top - window.innerHeight);
            const percent = Math.min(2, Math.max(-1, top / div.scrollHeight));
            const vh = 100 * top / window.innerHeight;

            dispatchSyntheticEvent('scroll-update', div, Object.create(null, {
                'percent': {value: percent},
                'vh': {value: vh},
            }));
        });

        const r = main.getBoundingClientRect();
        const top = -(r.top - window.innerHeight);
        const percent = Math.min(1, Math.max(0, top / main.scrollHeight));
        const vh = 100 * top / window.innerHeight;

        dispatchSyntheticEvent('scroll-update', main, Object.create(null, {
            'percent': {value: percent},
            'vh': {value: vh},
        }));
    }
    /**
     * Lazy load images function
     */
    function initLazyLoad() {
        sections.forEach(div => div.addEventListener('scroll-update', function once({data: {percent}, target: div}) {
            if (percent <= 0) {
                return;
            }
            let className = '.lazyload';
            if (mobile.matches) className = '.lazyloadM';

            div.removeEventListener('scroll-update', once);

            for (let lazy of Array.from(div.querySelectorAll(className))) {
                if (lazy.nodeName === 'IMG') {
                    /* lazy.setAttribute('sizes', lazy.getAttribute('data-sizes'));
                    lazy.setAttribute('srcset', lazy.getAttribute('data-srcset'));*/
                    lazy.setAttribute('src', lazy.getAttribute('data-src'));
                }
            }
        }));
    }

    let SetPlayer = function(videoClick, videoEmbed, videoClose, m) {
        let player = null;
        videoClick.addEventListener('click', () => {
            videoEmbed.style.left = '0px';
            videoClick.style.left = '-200%';
            scrollguide.style.visibility = 'hidden';
            if (player !== null) {
                player.play();
            } else {
                let vimID = videoEmbed.getAttribute('data-yt');
                let options = {
                    id: vimID,
                    autoplay: true,
                    loop: false,
                };

                player = new Vimeo.Player(videoEmbed.id, options);

                thisPlayer = player;

                videoClose.addEventListener('click', () => {
                    scrollguide.style.visibility = 'visible';
                    player.pause();
                    videoEmbed.style.left = '-100%';
                    videoClick.style.left = '0px';
                });
            }
        });
    };
    /**
     * Init a specific video
     * @param {String} m element id
     */
    function initSection1Part3Video(m) {
        const videoClick = gid('video-click_1_3');
        const videoEmbed = gid('video-embed_1_3');
        const videoClose = gid('video-close_1_3');
        new SetPlayer(videoClick, videoEmbed, videoClose, m);
    }
    /**
     * Init a specific video
     * @param {String} m element id
     */
    function initSection1Part4Video(m) {
        const videoClick = gid('video-click_1_4');
        const videoEmbed = gid('video-embed_1_4');
        const videoClose = gid('video-close_1_4');
        new SetPlayer(videoClick, videoEmbed, videoClose, m);
    }
    /**
     * Init a specific video
     * @param {String} m element id
     */
    function initSection2Part0Video(m) {
        const videoClick = gid('video-click_2_0');
        const videoEmbed = gid('video-embed_2_0');
        const videoClose = gid('video-close_2_0');
        new SetPlayer(videoClick, videoEmbed, videoClose, m);
    }
    /**
     * Init a specific video
     * @param {String} m element id
     */
    function initSection3Part0Video(m) {
        const videoClick = gid('video-click_3_0');
        const videoEmbed = gid('video-embed_3_0');
        const videoClose = gid('video-close_3_0');
        new SetPlayer(videoClick, videoEmbed, videoClose, m);
    }

    /**
     * Init a specific video
     * @param {String} m element id
     */
    function initSection0Timeline() {
        const timeline = new TimelineLite();
        const duration = 200;
        timeline.pause();
        timeline.duration(duration);
        section.style.height = (duration-100)+'vh';
        navArr.push(0);
        timeline.to(cnnHeader, 50, {top: '-=60'}, 100);
        timeline.to(sponsorContentHeader, 50, {top: '-=60'}, 100);

        timeline.to(siteNavFlood, 50, {top: '50px'}, 100);
        timeline.set(header, {display: 'none'}, 200);

        siteNavFlood.addEventListener('click', function() {
            window.location.href = 'http://sponsorcontent.cnn.com/interactive/SERVPRO/FightingTheElements/';
        });

        section.addEventListener('scroll-update', ({data: {vh}}) => timeline.seek(Math.max(0, Math.min(duration, vh)), false));
    }

    /**
     * Init a specific video
     * @param {String} m element id
     */
    function initSection1Timeline() {
        const timeline = new TimelineLite();
        let duration = 950;

        timeline.pause();
        timeline.duration(duration);
        section1.style.height = (duration-100)+'vh';
        timeline.to(bg1, 50, {top: '-=0vh'}, 0);
        timeline.to(bg1, 50, {top: '-=100vh'}, 50);

        timeline.to(storyVideo, 50, {top: '-=100vh'}, 100);
        navArr.push(100);

        timeline.to(storyVideo, 0, {visibility: 'visible'}, 100);
        timeline.to(storyVideo, 50, {top: '-=100vh'}, 225);
        navArr.push(225);
        timeline.to(servproText, 0, {opacity: 1}, 225);
        timeline.to(servproText, 50, {top: '-=100vh'}, 225);
        // checked
        let myTween5 = TweenLite.to(scrollcopy5, 50, {top: '-='+(scrollcopy5.offsetHeight-scrollwrapper5.offsetHeight)});
        timeline.add(myTween5, 275);
        if (scrollcopy5.offsetHeight<scrollwrapper5.offsetHeight) timeline.remove(myTween5);

        timeline.to(servproText, 100, {top: '-=100vh'}, 350);
        timeline.to(textMapBase, 100, {top: '-=100vh'}, 350);

        let myTween = TweenLite.to(scrollcopy1, 200, {top: '-='+(scrollcopy1.offsetHeight-scrollwrapper1.offsetHeight)});
        timeline.add(myTween, 425);
        if (scrollcopy1.offsetHeight<scrollwrapper1.offsetHeight) timeline.remove(myTween);
        navArr.push(425);
        // checked
        let base = 475;

        if (!mobile.matches) {
            timeline.to(s1Item1, 50, {opacity: 1}, base);
            timeline.to(s1Item7, 25, {opacity: 1}, base);
            timeline.to(s1Item8, 25, {opacity: 1}, base);
            timeline.to(s1Item2, 25, {opacity: 1}, base+25);
            timeline.to(s1Item2, 25, {opacity: 0}, base+50);
            timeline.to(s1Item3, 25, {opacity: 1}, base+50);
            timeline.to(s1Item3, 25, {opacity: 0}, base+75);
            timeline.to(s1Item4, 25, {opacity: 1}, base+75);
            timeline.to(s1Item4, 25, {opacity: 0}, base+100);
            timeline.to(s1Item5, 25, {opacity: 1}, base+100);
            timeline.to(s1Item5, 25, {opacity: 0}, base+125);
            timeline.to(s1Item6, 25, {opacity: 1}, base+125);
            timeline.to(mapLayers, 25, {top: '-=100vh'}, base+150);
            timeline.to(storyImage, 25, {opacity: 1}, base+150);
            timeline.to(s1Item1, 50, {opacity: 0}, base+150);
            timeline.to(storyImage, 50, {top: '-=100vh'}, base+200);
        }

        timeline.to(scrollwrapper1, 50, {top: '-=100vh'}, base+175);

        timeline.to(textMapBase, 50, {top: '-=100vh'}, base+200);
        timeline.to(poemVideo, 50, {top: '-=100vh'}, base+200);
        timeline.to(poemVideo, 0, {visibility: 'visible'}, base+200);
        navArr.push(650);
        timeline.to(poemVideo, 50, {top: '-=100vh'}, base+325);

        window.addEventListener('resize', () => {
            timeline.remove(myTween);
            timeline.remove(myTween5);
            scrollcopy5.style.top = 0+'px';// Ugly bt works
            myTween5 = TweenLite.to(scrollcopy5, 50, {top: '-='+(scrollcopy5.offsetHeight-scrollwrapper5.offsetHeight)});
            timeline.add(myTween5, 275);
            if (scrollcopy5.offsetHeight<scrollwrapper5.offsetHeight) timeline.remove(myTween5);

            scrollcopy1.style.top = 0+'px';// Ugly bt works
            myTween = TweenLite.to(scrollcopy1, 200, {top: '-='+(scrollcopy1.offsetHeight-scrollwrapper1.offsetHeight)});
            timeline.add(myTween, 425);
            if (scrollcopy1.offsetHeight<scrollwrapper1.offsetHeight) timeline.remove(myTween);
            setQuality();
        });

        section1.addEventListener('scroll-update', ({data: {vh}}) => timeline.seek(Math.max(0, vh), false));
        console.log('C');
    }

    /**
     * Init a specific video
     */
    function initSection2Timeline() {
        const timeline = new TimelineLite();
        let duration = 750;
        if (sectionThree) duration = 850;
        timeline.pause();
        timeline.duration(duration);

        const section2 = gid('section-2');
        const bg2 = section2.querySelector('.fixed_container');

        section2.style.height = (duration-100)+'vh';

        timeline.to(bg2, 50, {top: '-=0vh'}, 0);
        timeline.to(bg2, 50, {top: '-=100vh'}, 0);

        navArr.push(0);
        timeline.to(storyVideo21, 0, {visibility: 'visible'}, 0);
        timeline.to(storyVideo21, 100, {top: '-=100vh'}, 125);
        timeline.to(s2Item1, 0, {opacity: 1}, 125);
        timeline.to(s2Item1, 0, {left: 0}, 125);
        timeline.to(slideshow21, 0, {visibility: 'visible'}, 125);
        timeline.to(slideshow21, 100, {top: '-=100vh'}, 125);
        navArr.push(150);
        let base = 250;
        let sp = 60;
        timeline.to(s2Item1, 50, {left: '-=100vw'}, base);
        timeline.to(s2Item2, 50, {left: '-=100vw'}, base);

        timeline.to(s2Item2, 50, {left: '-=100vw'}, base+(sp));
        timeline.to(s2Item3, 50, {left: '-=100vw'}, base+(sp));

        timeline.to(s2Item3, 50, {left: '-=100vw'}, base+(sp*2));
        timeline.to(s2Item4, 50, {left: '-=100vw'}, base+(sp*2));

        timeline.to(s2Item4, 50, {left: '-=100vw'}, base+(sp*3));
        timeline.to(s2Item5, 50, {left: '-=100vw'}, base+(sp*3));

        timeline.to(s2Item5, 50, {left: '-=100vw'}, base+(sp*4));
        timeline.to(s2Item6, 50, {left: '-=100vw'}, base+(sp*4));

        timeline.to(s2Item6, 50, {left: '-=100vw'}, base+(sp*5));
        timeline.to(s2Item7, 50, {left: '-=100vw'}, base+(sp*5));
        // if(sectionThree) timeline.to(slideshow21, 50, { top: '-=100vh' }, 600);

        section2.addEventListener('scroll-update', ({data: {vh}}) => timeline.seek(Math.max(0, vh), false));
    }
    /**
     * Init a specific video
     */
    function initSection3Timeline() {
        const timeline = new TimelineLite();
        let duration = 300;
        timeline.pause();
        timeline.duration(duration);

        section3.style.height = (duration)+'vh';

        navArr.push(0);
        timeline.to(bg3, 50, {top: '-=0vh'}, 0);
        timeline.to(bg3, 50, {top: '-=100vh'}, 0);

        timeline.to(storyVideo30, 0, {visibility: 'visible'}, 0);
        timeline.to(storyVideo30, 50, {top: '-=100vh'}, 125);
        navArr.push(150);
        timeline.to(subSection3Image, 50, {top: '-=100vh'}, 125);
        timeline.to(mobileInfographic38, 50, {top: '-='+(subSection3Image.offsetHeight-mobileInfographic38.offsetHeight)}, 170);

        section3.addEventListener('scroll-update', ({data: {vh}}) => timeline.seek(Math.max(0, vh), false));
    }
}());
